import React, { useState } from "react";
import { pxToRem, toNumberFixed } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Button, Image, Input, Toast } from "antd-mobile";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { isEmpty } from "lodash";
import { showGlobalLoading } from "../globalLoading";
import API from "@/api";
import useCustomTranslation from "@/hooks/useTranslation";

const PlayerAddress: React.FC<{
	data: Record<string, any>;
	onVisiblePopup: (visible: boolean) => void;
}> = ({ data, onVisiblePopup }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { showLoading, hideLoading } = showGlobalLoading();
	const [value, setValue] = useState("");
	const [disabled, setDisabled] = useState(false);
	const { balance } = useSelector((state: RootState) => state.auth);

	const onSubmitHandle = async () => {
		const balanceValue = balance["usableBalance"];
		if (isEmpty(value) || +value > balanceValue) {
			return Toast.show({
				content: t("InsufficientDaichunAmount"),
				position: "top",
			});
		}
		try {
			showLoading();
			setDisabled(true);
			const params: any = {
				refId: data.uid,
				coin: value,
			};
			const result: any = await API.finances.apiFinanceAgentDeposit(
				params
			);
			if (result?.code === 0) {
				Toast.show({
					content: t("SubmittedSucce"),
					position: "top",
				});
			}
		} catch (error) {
			console.log("---apiFinanceAgentDeposit--:", error);
		} finally {
			hideLoading();
			setDisabled(false);
			onVisiblePopup(false);
		}
	};
	return (
		<div className={classes.applyProportionWrap}>
			<h3>{t("PlayerAddress")}</h3>
			<div className="infoRights">
				<div className="user">
					<div>
						<Image
							src={require("@/assets/images/icons/Avatar.png")}
							width={14}
							height={14}
						/>
						<span>{data.nickname}</span>
						{data.inviteRemake && (
							<span>({data.inviteRemake})</span>
						)}
					</div>
				</div>
				<div className="addr">
					<p>{data.walletAddress}</p>
				</div>
			</div>
			<h3>{t("DaicunAmount")}</h3>
			<div className="inputWrap">
				<Input
					value={value}
					onChange={(val) => {
						setValue(val);
					}}
					type="number"
					placeholder={t("PleaseEnterGiftAmount")}
					style={{
						height: pxToRem(46),
						borderRadius: pxToRem(8),
						"--color": "#FFFFFF",
						"--text-align": "center",
						border: "1px solid #4C66C7",
						backgroundColor: "#181A22",
					}}
				/>
			</div>
			<div className="balanceInfo">
				<div>
					<span>{t("Balance")}</span>
					<strong style={{ marginLeft: pxToRem(5) }}>
						{toNumberFixed(balance["usableBalance"], 2)} USDT
					</strong>
				</div>
				<div>
					<span>{t("EstimatedFee")}</span>
					<strong style={{ marginLeft: pxToRem(5) }}>
						0.00 USDT
					</strong>
				</div>
			</div>
			<Button
				onClick={() => {
					onSubmitHandle();
				}}
				block
				disabled={disabled}
				shape="rounded"
				style={{
					height: pxToRem(50),
					fontSize: pxToRem(16),
					fontWeight: "700",
					"--border-width": "0",
					"--text-color": "#FFFFFF",
					background:
						" linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
				}}
			>
				{t("Gift")}
			</Button>
		</div>
	);
};

export default PlayerAddress;

const useStyles = createUseStyles({
	applyProportionWrap: {
		padding: {
			left: pxToRem(14),
			right: pxToRem(14),
			bottom: pxToRem(38),
		},
		background: "linear-gradient(to bottom right, #181B24 0, #232C48 100%)",
		"& h3": {
			color: "#FFFFFF",
			fontSize: pxToRem(14),
			fontWeight: "500",
			lineHeight: pxToRem(22),
			padding: {
				top: pxToRem(10),
				bottom: pxToRem(6),
			},
		},
		"& .inputWrap": {
			display: "flex",
			alignItems: "center",
			"& .input": {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: pxToRem(46),
				color: "#FFFFFF",
				fontSize: pxToRem(18),
				fontWeight: pxToRem(500),
				borderRadius: pxToRem(8),
				border: "1px solid #4C66C7",
				backgroundColor: "#181A22",
			},
		},
		"& .balanceInfo": {
			padding: {
				top: pxToRem(8),
				bottom: pxToRem(16),
			},
			"& >div": {
				fontSize: pxToRem(14),
				fontWeight: pxToRem(500),
				lineHeight: pxToRem(22),
			},
			"& span": {
				color: "#868FA8",
			},
			"& strong": {
				color: "#FFFFFF",
			},
		},
		"& .infoRights": {
			position: "relative",
			height: pxToRem(104),
			padding: pxToRem(12),
			border: "1px solid #4C66C7",
			borderRadius: pxToRem(8),
			backgroundColor: "#181A22",
			"& .user": {
				display: "flex",
				alignItems: "center",
				// justifyContent: "center",
				minWidth: pxToRem(92),

				color: "#FFFFFF",
				fontSize: pxToRem(12),
				fontWeight: "500",
				marginBottom: pxToRem(6),
				"& >div": {
					display: "flex",
					height: pxToRem(24),
					padding: {
						left: pxToRem(6),
						right: pxToRem(6),
						top: pxToRem(5),
						bottom: pxToRem(5),
					},
					borderRadius: pxToRem(6),
					backgroundColor: "#4C66C7",
				},
				"& span": {
					paddingLeft: pxToRem(3),
				},
			},
			"& .addr": {
				color: "#F7F9FF",
				fontSize: pxToRem(16),
				fontWeight: "500",
				lineHeight: pxToRem(24),
				wordBreak: "break-word",
			},
		},
	},
});
